import { ErrorBoundary, JSXElement, Match, mergeProps, Switch } from 'solid-js';
import { logErrorToSentry } from '~/utils/productLogging/sentry.ts';
import ContactSupport from '~/components/ErrorBoundaries/ContactSupport.tsx';
import GenericEnvAppError from '~/pages/ExternalPages/commons/Errors/GenericEnvAppError.tsx';
import { getLocalizedString } from '~/i18n/utils.ts';
import { getTranslationKey } from '~/pages/ExternalPages/EnvAppPages/Passkeys/utils.ts';
import { AppErrors } from '~/components/ErrorBoundaries/utils.ts';

type EnvAppPagesErrorBoundaryProps = {
  children: JSXElement;
};

export default function EnvAppPagesErrorBoundary(
  props: EnvAppPagesErrorBoundaryProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <ErrorBoundary
      fallback={(err) => {
        console.error(err);
        logErrorToSentry(err);
        return (
          <Switch fallback={<ContactSupport showLogo={false} />}>
            <Match
              when={err && err.message === AppErrors.ENV_PAGES_UNAUTHORIZED}
            >
              <GenericEnvAppError
                header={getLocalizedString(
                  getTranslationKey('passkey_unauthorized_error_title')
                )}
                subheader={getLocalizedString(
                  getTranslationKey('passkey_unauthorized_error_subtitle')
                )}
              />
            </Match>
            <Match
              when={err && err.message === AppErrors.NO_AVAILABLE_CONNECTIONS}
            >
              <GenericEnvAppError
                header={getLocalizedString(
                  getTranslationKey('passkey_connection_not_found_error_title')
                )}
                subheader={getLocalizedString(
                  getTranslationKey(
                    'passkey_connection_not_found_error_subtitle'
                  )
                )}
              />
            </Match>
          </Switch>
        );
      }}
    >
      {merged.children}
    </ErrorBoundary>
  );
}
